import { type ReactNode } from 'react'
import { ContentLoading } from '@/components/ContentLoading'
import {
  StickyViewHeader,
  StickyViewHeaderExtras,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'
import { useScrollOffsets } from '@/hooks/element-hooks'
import styles from './JobManagement.module.css'

export interface JobManagementProps {
  isInitialSearchRunning: boolean
  heading: ReactNode
  filterHeading: ReactNode
  children: ReactNode
}

export function JobManagement({
  isInitialSearchRunning,
  heading,
  filterHeading,
  children,
}: JobManagementProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <div className={styles.root} ref={scrollRef}>
      {isInitialSearchRunning ? (
        <ContentLoading />
      ) : (
        <>
          <StickyViewHeader scrollOffset={scrollOffset}>
            <StickyViewHeaderMain>{heading}</StickyViewHeaderMain>

            <StickyViewHeaderExtras>{filterHeading}</StickyViewHeaderExtras>
          </StickyViewHeader>

          <div className={styles.content}>{children}</div>
        </>
      )}
    </div>
  )
}
